import { render, staticRenderFns } from "./TepPreliquidacionInternoTabla.vue?vue&type=template&id=6d19f718"
import script from "./TepPreliquidacionInternoTabla.vue?vue&type=script&lang=js"
export * from "./TepPreliquidacionInternoTabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports